import { render, staticRenderFns } from "./PermissionsForm.vue?vue&type=template&id=804c28dc&scoped=true&"
import script from "./PermissionsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsForm.vue?vue&type=style&index=0&id=804c28dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804c28dc",
  null
  
)

export default component.exports